import { useEffect, useMemo, useRef, useState } from "react";
import { useSelector } from "react-redux";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Skeleton,
  TextField,
  Typography,
} from "@mui/material";
import { fieldsToCheckFeeSimple } from "../../../../../../../../data/permitFormsData";
import { feeSimpleLabel } from "../../../../../../../../data/buildingPermit/fieldDatas";

const FEE_SIMPLE_FIELD_NAMES = ["fee_simple_name", "fee_simple_address"];

const RenderFeeSimple = ({ full_title, feeSimple, onChange, fields }) => {
  const hasValidatedOnce = useRef(false);

  const savedProjects = useSelector((state) => state.nocData?.saved_projects);
  const { addingNewFeeSimple, createDocLoading } = useSelector(
    (state) => state.buildingState,
  );

  const [feeSimpletList, setFeeSimpleList] = useState([]);
  const [loadingData, setLoadingData] = useState(true);

  useEffect(() => {
    setFeeSimpleList(savedProjects?.feeSimple || []);
    setLoadingData(false);
  }, [savedProjects?.feeSimple]);

  const fieldMap = useMemo(
    () => Object.fromEntries((fields || []).map((f) => [f.name, f])),
    [fields],
  );

  useEffect(() => {
    // Run only if we haven’t validated AND projectList has loaded
    if (!hasValidatedOnce.current && feeSimpletList.length > 0 && feeSimple) {
      const selectedId = feeSimple?.value;
      const selected = feeSimpletList.find((pro) => pro.id === selectedId);

      if (!selected) {
        onChange("feeSimpleTitleholder", "");
        FEE_SIMPLE_FIELD_NAMES.forEach((name) => onChange(name, ""));
      }
      hasValidatedOnce.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [feeSimpletList, feeSimple]);

  const handleSelectChange = (event) => {
    const selectedId = event.target.value;
    const selected = feeSimpletList.find((p) => p.id === selectedId);

    onChange("feeSimpleTitleholder", {
      value: selectedId,
      label: selected?.["fee_simple_name"],
    });
    FEE_SIMPLE_FIELD_NAMES.forEach((name) =>
      onChange(name, selected?.[name] || ""),
    );
  };

  const selectedPro = feeSimpletList?.find(
    (pro) => pro.id === feeSimple?.value,
  );

  if (loadingData) {
    return <Skeleton variant="rectangular" height={120} />; // or CircularProgress etc.
  }
  return (
    <>
      <Typography align="center" mt={2} mb={0} variant="h6">
        {full_title}
      </Typography>

      <FormControl
        fullWidth
        margin="normal"
        variant="filled"
        sx={{
          "& .MuiFilledInput-root": {
            border: feeSimple ? "2px solid #004976" : undefined, // adjust thickness and color
            borderRadius: "14px",
            backgroundColor: "transparent", // optional
          },
          "& .MuiFilledInput-underline:before": {
            borderBottom: "none", // remove default bottom border
          },
          "& .MuiFilledInput-underline:after": {
            borderBottom: "none",
          },
        }}
      >
        <InputLabel>Select Fee Simple Title Holder Contact</InputLabel>
        <Select
          disabled={createDocLoading || addingNewFeeSimple}
          name="feeSimpleTitleholder"
          value={feeSimple?.value || ""}
          onChange={handleSelectChange}
          MenuProps={{
            PaperProps: {
              style: {
                marginTop: "1.5px",
                maxHeight: 200,
                width: "auto",
                maxWidth: "100%",
              },
            },
          }}
        >
          <MenuItem disabled value="">
            {feeSimpletList.length === 0 ? "No records found" : "Select One"}
          </MenuItem>
          {feeSimpletList?.map((option, i) => (
            <MenuItem key={option.id + i} value={option.id}>
              {option.fee_simple_name || "Unnamed"}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {feeSimple && selectedPro && (
        <>
          {fieldsToCheckFeeSimple?.map((field, i) => (
            <TextField
              key={field + i}
              fullWidth
              margin="normal"
              variant="filled"
              label={feeSimpleLabel[field]}
              name={field}
              value={
                field === "fee_simple_name"
                  ? feeSimple?.label
                  : fieldMap[field]?.value || ""
              }
              disabled={!addingNewFeeSimple}
            />
          ))}
        </>
      )}
      {/* <Box sx={{ border: "2px solid #d3d3d3" }} mt={1}></Box> */}
    </>
  );
};

export default RenderFeeSimple;
